import { useState } from "react";

// STYLES
import * as Style from "./EditSupportItemStyle";

// LIBRARIES
import { useTranslation } from "react-i18next";

// MISC
import { ButtonTypes, ModalTypes, SnackbarTypes } from "models/GeneralTypes/generalTypes";
import { IEditCategory, IGetParentChildren } from "models/interfaces";
import { IModalData } from "../../ModalAtomModel";
import { IProps } from "./EditSupportItemModel";

// ASSETS

// REDUX
import { deleteCategory, deleteSubcategory, editCategory, editSubcategory, getAllCategories, getCategorySubcategories } from "api/supportApi";
import { useAppDispatch, useAppSelector } from "hooks/reduxHooks";
import { language } from "slices/sessionSlice";
import { modalProps, toggleModalState, toggleSnackbarState } from "slices/uiSlice";

// COMPONENTS
import ButtonAtom from "components/Atoms/ButtonAtom/ButtonAtom";
import InputAtom from "components/Atoms/InputAtom/InputAtom";


const EditSupportItem = (props: IProps) => {
  // PROPS
  const { handleClose = () => { } } = props;

  // CONSTANTS USING LIBRARIES
  const dispatch = useAppDispatch();
  const modalData = useAppSelector<IModalData>(modalProps);
  const selectedLanguage = useAppSelector<string>(language);
  const { t } = useTranslation();

  // CONSTANTS USING HOOKS
  const [inputValue, setInputValue] = useState<string>(modalData.type === ModalTypes.EDIT_CATEGORY ? modalData?.category?.name || "" : modalData?.subcategory?.name || "");

  // GENERAL CONSTANTS

  // USE EFFECT FUNCTION

  // REQUEST API FUNCTIONS

  // HANDLERS FUNCTIONS
  const handleEditItem = () => {
    if (modalData.type === ModalTypes.EDIT_CATEGORY) {
      let payload: IEditCategory = {
        id: modalData.category.id,
        language: selectedLanguage,
        title: inputValue
      };
      dispatch(editCategory(payload))
        .then(() => {
          dispatch(getAllCategories(selectedLanguage))
            .then(() => {
              dispatch(
                toggleModalState({
                  ...modalData,
                  isVisible: false,
                  type: "",
                  subcategory: null,
                  article: null,
                })
              );
              dispatch(toggleSnackbarState({
                isVisible: true,
                type: SnackbarTypes.SUPPORT_EDIT_SUCCESS,
                item: t("snackbar.category"),
              }))
            });
        })
        .catch((error) => {
          console.log(error)
          dispatch(toggleSnackbarState({
            isVisible: true,
            type: SnackbarTypes.SUPPORT_ERROR,
          }))
        })
    };
    if (modalData.type === ModalTypes.EDIT_SUBCATEGORY) {
      let payload: IEditCategory = {
        id: modalData.subcategory.id,
        language: selectedLanguage,
        title: inputValue
      };
      dispatch(editSubcategory(payload))
        .then(() => {
          let payload: IGetParentChildren = {
            id: modalData.category.id,
            language: selectedLanguage
          };
          dispatch(getCategorySubcategories(payload))
            .then(() => {
              dispatch(
                toggleModalState({
                  ...modalData,
                  isVisible: false,
                  type: "",
                  article: null,
                })
              );
              dispatch(toggleSnackbarState({
                isVisible: true,
                type: SnackbarTypes.SUPPORT_EDIT_SUCCESS,
                item: t("snackbar.subcategory"),
              }))
            });
        })
        .catch((error) => {
          console.log(error)
          dispatch(toggleSnackbarState({
            isVisible: true,
            type: SnackbarTypes.SUPPORT_ERROR,
          }))
        })
    };
  };

  const handleDeleteItem = () => {
    if (modalData.type === ModalTypes.EDIT_CATEGORY) {
      dispatch(deleteCategory(modalData.category.id))
        .then(() => {
          dispatch(getAllCategories(selectedLanguage))
            .then(() => {
              dispatch(
                toggleModalState({
                  ...modalData,
                  isVisible: false,
                  type: "",
                  category: null,
                  subcategory: null,
                  article: null,
                })
              );
              dispatch(toggleSnackbarState({
                isVisible: true,
                type: SnackbarTypes.SUPPORT_DELETE_SUCCESS,
                item: t("snackbar.category"),
              }))
            });
        })
        .catch((error) => {
          console.log(error)
          dispatch(toggleSnackbarState({
            isVisible: true,
            type: SnackbarTypes.SUPPORT_ERROR,
          }))
        })
    };
    if (modalData.type === ModalTypes.EDIT_SUBCATEGORY) {
      dispatch(deleteSubcategory(modalData.subcategory.id))
        .then(() => {
          let payload: IGetParentChildren = {
            id: modalData.category.id,
            language: selectedLanguage
          };
          dispatch(getCategorySubcategories(payload))
            .then(() => {
              dispatch(
                toggleModalState({
                  ...modalData,
                  isVisible: false,
                  type: "",
                  subcategory: null,
                  article: null,
                })
              );
              dispatch(toggleSnackbarState({
                isVisible: true,
                type: SnackbarTypes.SUPPORT_DELETE_SUCCESS,
                item: t("snackbar.subcategory")
              }))
            });
        })
        .catch((error) => {
          console.log(error)
          dispatch(toggleSnackbarState({
            isVisible: true,
            type: SnackbarTypes.SUPPORT_ERROR,
          }))
        })
    };
  };

  return (
    <Style.ConfirmationModalContainer>
      <Style.CloseIcon onClick={handleClose} />
      <Style.HeaderContainer>
        {modalData.type === ModalTypes.EDIT_CATEGORY ? t("editSupportItem.edit") + t("snackbar.category") : t("editSupportItem.edit") + t("snackbar.subcategory")}
      </Style.HeaderContainer>
      <Style.InputAtomContainer>
        <InputAtom
          placeholder={modalData.type === ModalTypes.EDIT_CATEGORY ? modalData?.category?.name : modalData.subcategory.name}
          hasLabel={true}
          label={t("page.pushNotifications.title")}
          inputValue={inputValue}
          setInputValue={setInputValue}
        />
      </Style.InputAtomContainer>
      <Style.ButtonsWrapper>
        <ButtonAtom
          onClick={inputValue ? handleEditItem : () => { }}
          text={t("support.edit")}
          type={ButtonTypes.NEW_MAIN_BUTTON}
          width="110px"
        />
        <ButtonAtom
          onClick={handleDeleteItem}
          text={t("support.delete")}
          type={ButtonTypes.NEW_BUTTON}
          width="110px"
        />
      </Style.ButtonsWrapper>
    </Style.ConfirmationModalContainer>
  );
};

export default EditSupportItem;
